import OpenCompanyUrl from '@/router/middlewares/OpenCompanyUrl'

// Instancia middlewares utilizados nas rotas
let openPrivacyPolicyMiddleware = new OpenCompanyUrl('company/legal', 'privacy_policy_url')
let openTermsMiddleware         = new OpenCompanyUrl('company/legal', 'terms_url')

export default [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
        meta: {
            title: 'company/home',
        },
    },
    {
        path: '/termos-de-uso',
        name: 'terms',
        // redirect: '/not-found',
        beforeEnter(to, from, next) {
            openTermsMiddleware.handle(to, from, next)
        },
        // component: () => import(/* webpackChunkName: "duvidas" */ '@/views/FAQ.vue')
    },
    {
        path: '/privacidade',
        name: 'privacy',
        // redirect: '/not-found',
        beforeEnter(to, from, next) {
            openPrivacyPolicyMiddleware.handle(to, from, next)
        },
        // component: () => import(/* webpackChunkName: "duvidas" */ '@/views/FAQ.vue')
    },
    {
        path: '/entrar',
        name: 'login',
        component: () => import(/* webpackChunkName: "entrar" */ '@/views/Login.vue')
    },
    {
        path: '/cadastro',
        name: 'register',
        component: () => import(/* webpackChunkName: "cadastrar" */ '@/views/Register.vue')
    },
    {
        path: '/*',
        name: 'not-found',
        component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue')
    },
]